import React, { ReactNode } from "react";
import {
  TouchableOpacity,
  StyleSheet,
  View,
  ActivityIndicator,
} from "react-native";
import CustomText from "@components/CustomText";
import { colors } from "@constants/theme";
import Text from "@components/CustomText";

interface BottomButtonProps {
  onPress?: () => void;
  title?: string;
  loading?: boolean;
  disable?: boolean;
  amount?: string;
  showPaymentText?: boolean;
  topAccessory?: ReactNode;
  /** Extra bottom padding for the nav-bar safe-area inset. Pass insets.bottom
   *  when this button is rendered inside a Modal (a separate window that does
   *  not inherit the app root's safe-area padding). Defaults to 0. */
  bottomInset?: number;
}

const BottomButton: React.FC<BottomButtonProps> = ({
  onPress = () => {},
  title = "",
  disable = false,
  loading = false,
  amount = "0",
  showPaymentText = false,
  topAccessory = null,
  bottomInset = 0,
}) => {
  return (
    <View
      style={[styles.absoluteContainer, { paddingBottom: 10 + bottomInset }]}
    >
      {topAccessory}
      {showPaymentText ? (
        <View style={styles.header}>
          <Text variant="subtitle_16">कस्टमर से पेमेंट लेना है</Text>
          <Text variant="heading_24" style={{ lineHeight: 30 }}>
            ₹{amount}
          </Text>
        </View>
      ) : null}
      <TouchableOpacity
        testID="docl-crate-scan"
        disabled={disable}
        activeOpacity={0.8}
        onPress={onPress}
        style={[
          styles.scanButton,
          { opacity: loading ? 0.8 : 1 },
          disable && { opacity: 0.8, backgroundColor: colors.black02 },
        ]}
      >
        {loading ? (
          <ActivityIndicator size="small" color={colors.white} />
        ) : (
          <CustomText variant="title_16" style={styles.scanButtonText}>
            {title}
          </CustomText>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default BottomButton;

const styles = StyleSheet.create({
  absoluteContainer: {
    backgroundColor: "white",
    position: "absolute",
    paddingBottom: 10,
    bottom: 0,
    width: "100%",
    padding: 16,
    elevation: 10,
  },
  scanButton: {
    backgroundColor: "#198155",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
  scanButtonText: {
    color: colors.white,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 8,
  },
});
